import Component from 'components/pages/Rewards/MobileTopUpRewards/MobileTopUpRewards';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('rewards');
export default buildPage(Component, {
  requiresAuthentication: true,
  metaData: {
    title: 'Mobile top up',
    description: 'Mobile top up',
  },
});
